import {
  createContext,
  Dispatch,
  useReducer,
  useEffect,
  useState,
  useMemo,
  ReactNode,
  memo,
} from "react";
import useDomain from "hooks/useDomain";
import { UserReducer, initState } from "./reducer";
import { UserActionsTypes, UserStateType, USER_UPDATE } from "./types";

import { v4 as uuidv4 } from "uuid";

import LoadingPage from "components/LoadingPage";

interface UserProviderProps {
  children: ReactNode;
}

interface IUserContext {
  state: UserStateType;
  dispatch: Dispatch<UserActionsTypes>;
}

const UserContext = createContext<IUserContext>({
  state: initState,
  dispatch: () => null,
});

export const UserProvider = memo(({ children }: UserProviderProps) => {
  const [isFisrtLoading, setIsFisrtLoading] = useState<boolean>(true);
  const { run, data, isIdle } = useDomain();

  const handleGetUser = async () => {
    await run((domain) => domain.current_user_use_case.execute());
    setTimeout(() => {
      setIsFisrtLoading(false);
    }, 10);
  };

  useEffect(() => {
    handleGetUser();
    // eslint-disable-next-line
  }, []);

  const [state, dispatch] = useReducer(UserReducer, initState);

  useEffect(() => {
    const setUserData = () => {
      dispatch({
        type: USER_UPDATE,
        payload: data,
      });
      window.localStorage.setItem("newUser", "true");
    };

    if (data) setUserData();

    // eslint-disable-next-line
  }, [data]);

  window.localStorage.setItem("userCode", state.data?.code as string);

  let existsStorage: string | null =
    window.localStorage.getItem("browser_storage");
  useEffect(() => {
    if (!existsStorage) {
      window.localStorage.setItem(
        "browser_storage",
        generateUuv5("da6b65da-b968-49af-b833-967ee693a230")
      );
    }
    // eslint-disable-next-line
  }, [existsStorage]);

  const generateUuv5 = (namespace: string): string => {
    let response: string = uuidv4();

    return response;
  };

  const providerValue = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch]
  );

  if (isIdle && isFisrtLoading) {
    return <LoadingPage isLoading={isFisrtLoading} />;
  }

  return (
    <>
      {isFisrtLoading || isIdle ? (
        <LoadingPage isLoading={isFisrtLoading} />
      ) : (
        <UserContext.Provider value={providerValue}>
          {children}
        </UserContext.Provider>
      )}
    </>
  );
});

export default UserContext;
